import { ChakraProvider } from '@chakra-ui/react'
import { QueryClient } from '@tanstack/query-core'
import { QueryClientProvider } from '@tanstack/react-query'
import type { AppProps } from 'next/app'
import { RecoilRoot } from 'recoil'
import { SketchProvider } from '../utils/useSketch'
import { Toaster } from 'react-hot-toast'
import theme from '../styles/theme'
import { DefaultSeo } from 'next-seo'
import config from '../next-seo.config'
import { AuthProvider } from '../context/AuthContext'
import mixpanel from "mixpanel-browser";

import '../styles/global.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      onError: () => {},
    },
    mutations: {
      onError: () => {},
    },
  },
})

mixpanel.init('7d82a7674f2f1b8e78d65608d67f22d5', {
  autocapture: true,
  record_sessions_percent: 100,
})

function MyApp({ Component, pageProps }: AppProps) {
  const naverMapKey = process.env.NEXT_PUBLIC_NAVER_MAP_KEY
  return (
    <QueryClientProvider client={queryClient}>
      <DefaultSeo {...config} />
      <RecoilRoot>
        <AuthProvider>
          <ChakraProvider theme={theme}>
            <SketchProvider>
              <Toaster />
              <Component {...pageProps} />
            </SketchProvider>
          </ChakraProvider>
        </AuthProvider>
      </RecoilRoot>
    </QueryClientProvider>
  )
}

export default MyApp
